import {
  DomainName,
  ITreeNodeControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  DictionaryTreeFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

import {
  controlDomain,
  getControlValueHistory,
  getValueFromArgsOrConfig,
} from './helpers';

const buildDictTreeControl = async (
  viewModel: FormViewModel,
  item: ITreeNodeControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<DictionaryTreeFormControlViewModel> => {
  if (!item.outParams) {
    throw new Error('out params is required for DictTreeControl');
  }

  return {
    tree: item.tree,
    hasValue: true,
    hasHistory: true,
    columns: item.columns,
    noLabel: item.noLabel,
    type: FormControlViewModelType.TREE_INPUT,
    labelWidth: item.labelWidth,
    name: item.name,
    disabled: item.disabled,
    visible: item.visible,
    category: item.tree.Category,
    value: getValueFromArgsOrConfig(item, args, viewModel.source, ''),
    inParams: {},
    outParams: item.outParams,
    required: item.required,
    updater: item.updater,
    storeValue: item.storeValue,
    readonly: item.readonly || viewModel.source.type === FormSourceType.REVIEW,
    enableButtonOnReadOnly: viewModel.source.type !== FormSourceType.REVIEW,
    canClearOnReadOnly: item.canClearOnReadOnly,
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    history: getControlValueHistory(viewModel.source, item.name),
    maxLength: (
      (await controlDomain(item, viewModel.source, domains)) as StringDomain
    ).length,
    ...localizedProps,
  };
};

export default buildDictTreeControl;
